// Stacked database cylinder, for "pull the values straight out of the
// county's own data" actions. Already stroke-driven via currentColor, so it
// takes its color from whatever wraps it (e.g. the green icon badge on the
// Fetch from data button).
export const DatabaseIcon = (props) => {
  return (
    <svg fill="none" height={24} viewBox="0 0 24 24" width={24} {...props}>
      <path d="M5 12V18C5 18 5 21 12 21C19 21 19 18 19 18V12" stroke="currentColor" strokeWidth={1.5} />
      <path d="M5 6V12C5 12 5 15 12 15C19 15 19 12 19 12V6" stroke="currentColor" strokeWidth={1.5} />
      <path d="M12 3C19 3 19 6 19 6C19 6 19 9 12 9C5 9 5 6 5 6C5 6 5 3 12 3Z" stroke="currentColor" strokeWidth={1.5} />
    </svg>
  );
};
